﻿'use strict';

angular.module('ntmApp').factory('CalendarDataProperty', function () {

    function CalendarDataProperty(dataProperty) {

        var self = this;
        self.data = {};

        function initialize() {
            dataProperty.datePropertyDisplay = dataProperty.datePropertyDisplay ? JSON.parse(dataProperty.datePropertyDisplay) : null;
            dataProperty.datePropertyData.forEach(function (item) {
                self.data[moment(item[dataProperty.datePropertyColumn]).format('YYYY-MM-DD')] = composeDayData(item);
                if (self.data[moment(item[dataProperty.datePropertyColumn]).format('YYYY-MM-DD')]) {
                    self.data[moment(item[dataProperty.datePropertyColumn]).format('YYYY-MM-DD')].hideButtons = self.data[moment(item[dataProperty.datePropertyColumn]).format('YYYY-MM-DD')].hideButtons || [];
                }
            });
        }

        function checkCondition(conditions, item) {
            if (!conditions) {
                return;
            }

            var result = '';

            conditions.forEach(function (condition) {

                if (condition.andor && condition.andor === 'and') {
                    result += '&&';
                }

                if (condition.andor && condition.andor === 'or') {
                    result += '||';
                }

                if (condition.paren && condition.paren === '(') {
                    result += '(';
                }

                condition.operator = condition.operator || '=';

                switch (condition.operator) {
                    case '=': case 'equals':
                        result += '"{0}"=="{1}"'.format(item[condition.field], condition.value);
                        break;

                    case 'notEqualTo': case 'not equal': case 'not equal to': case '!=':
                        result += '"{0}"!="{1}"'.format(item[condition.field], condition.value);
                        break;

                    case 'lessThan': case 'less than': case '<':
                        result += '"{0}"<"{1}"'.format(item[condition.field], condition.value);
                        break;

                    case 'greaterThan': case 'greater than': case '>':
                        result += '"{0}">"{1}"'.format(item[condition.field], condition.value);
                        break;

                    case 'lessThanOrEquals': case 'less than or equal to': case 'lessThanOrEqualTo': case '<=':
                        result += '"{0}"<="{1}"'.format(item[condition.field], condition.value);
                        break;

                    case 'greaterThanOrEquals': case 'greater than or equal to': case 'greaterThanOrEquals': case '>=':
                        result += '"{0}">="{1}"'.format(item[condition.field], condition.value);
                        break;

                    case 'startsWith': case 'starts with': case 'StartWith':
                        result += '"{0}".startsWith("{1}")'.format(item[condition.field], condition.value);
                        break;

                    case 'contains':
                        result += '"{0}".indexOf("{1}")!=-1'.format(item[condition.field], condition.value);
                        break;

                    case 'in': case 'inList':
                        result += '"{0}".indexOf("{1}")!=-1'.format(condition.value, item[condition.field]);
                        break;

                    case 'not in': case 'notIn': case 'notInList':
                        result += '"{0}".indexOf("{1}")==-1'.format(condition.value, item[condition.field]);
                        break;

                    case 'is null': case 'isNull':
                        result += item[condition.field] === null || item[condition.field] === undefined;
                        break;

                    case 'is not null': case 'isNotNull':
                        result += item[condition.field] !== null && item[condition.field] !== undefined;
                        break;

                    case 'between':
                        result += '"{0}">"{1}"&&"{2}"<"{3}"'.format(item[condition.field], condition.value, item[condition.field], condition.highValue);
                        break;
                }

                if (condition.paren && condition.paren === ')') {
                    result += ')';
                }
            });

            return result === '' ? false : eval(result); //jshint ignore:line
            
        }

        function composeDayData(item) {
            var result = dataProperty.datePropertyDisplay ? dataProperty.datePropertyDisplay.filter(function (property) { return checkCondition(property.conditions, item); }) : [];
            
            if (result.length > 0) {
                return result[0].display;
            }

            return null;
        }

        initialize();
      

    }

    return (CalendarDataProperty);

});